'use strict';

var buildRelativeAliases = require('../internal/buildRelativeAliases');

buildRelativeAliases();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/build/buildRelativeAliasesCall.js
// module id = 17
// module chunks = 0